import { ConfigProvider } from 'antd'

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: 'Klean, sans-serif',
          borderRadius: 0,
          colorBorder: '#757575',
          colorPrimary: '#2b2b2b',
          colorInfo: '#2b2b2b',
          lineWidth: 2,
          fontSize: 16,
        },
        components: {
          Button: {
            primaryColor: '#2b2b2b',
            primaryShadow: '0',
            defaultShadow: '0',
            dangerShadow: '0',
          },
          Input: {
            borderRadius: 0,
            colorText: '#2b2b2b',
            colorTextPlaceholder: '#6e6e6e',
            hoverBorderColor: '#2b2b2b',
            colorBorder: '#757575',
            activeBorderColor: '#2b2b2b',
            colorTextDisabled: '#6e6e6e',
            fontSizeLG: 16,
          },
          Pagination: {
            itemBg: 'transparent',
            itemActiveBg: 'transparent',
            itemActiveBgDisabled: 'transparent',
          },
          Carousel: {
            arrowSize: 28,
          },
          Tag: {
            colorBorder: '#d9d9d9',
            lineWidth: 1,
          },
          Anchor: {
            linkPaddingBlock: 0,
            linkPaddingInlineStart: 0,
          },
          Breadcrumb: {
            fontSize: 12,
          },
          Table: {
            fontSize: 14,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default ThemeProvider
